window.WL = (function(){

  var KEY = 'nt_wishlist';

  function getItems(){
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch(e){ return []; }
  }

  function saveItems(items){
    localStorage.setItem(KEY, JSON.stringify(items));
  }

  function isWishlisted(id){
    return getItems().some(function(i){ return String(i.id) === String(id); });
  }

  function toggle(btn){
    var id    = btn.getAttribute('data-product-id');
    var items = getItems();
    var idx   = -1;
    items.forEach(function(item, i){ if(String(item.id) === String(id)) idx = i; });

    if(idx > -1){
      items.splice(idx, 1);
      btn.classList.remove('is-active');
    } else {
      items.push({
        id:     id,
        handle: btn.getAttribute('data-product-handle'),
        title:  btn.getAttribute('data-product-title'),
        price:  btn.getAttribute('data-product-price'),
        image:  btn.getAttribute('data-product-image'),
        url:    btn.getAttribute('data-product-url')
      });
      btn.classList.add('is-active');
    }

    saveItems(items);
    updateBadge();
  }

  function updateBadge(){
    var count = getItems().length;
    var badge = document.getElementById('wl-count-badge');
    if(!badge) return;
    badge.textContent = count;
    if(count > 0){
      badge.classList.add('visible');
    } else {
      badge.classList.remove('visible');
    }
  }

  function initButtons(){
    document.querySelectorAll('.cg-wish[data-product-id]').forEach(function(btn){
      if(isWishlisted(btn.getAttribute('data-product-id'))){
        btn.classList.add('is-active');
      }
    });
    updateBadge();
  }

  function renderItems(){
    var items     = getItems();
    var container = document.getElementById('WLItems');
    var footer    = document.getElementById('WLFooter');
    var countEl   = document.getElementById('wl-popup-count');
    if(!container) return;

    if(countEl) countEl.textContent = items.length > 0 ? '(' + items.length + ' items)' : '';
    if(footer)  footer.style.display = items.length > 0 ? 'block' : 'none';

    if(items.length === 0){
      container.innerHTML =
        '<div class="wl-empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
            '<path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>' +
          '</svg>' +
          '<p class="wl-empty__title">Your wishlist is empty</p>' +
          '<p class="wl-empty__sub">Save items you love and come back to them later.</p>' +
          '<a href="/collections/all" class="wl-shop-btn">Browse Products</a>' +
        '</div>';
      return;
    }

    container.innerHTML = items.map(function(item){
      return '<div class="wl-item">' +
        '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
        '<div class="wl-item__info">' +
          '<p class="wl-item__name">' + item.title + '</p>' +
          '<p class="wl-item__price">' + item.price + '</p>' +
          '<div class="wl-item__actions">' +
            '<a href="' + item.url + '" class="wl-item__view">View</a>' +
            '<button class="wl-item__remove" onclick="WL.remove(\'' + item.id + '\')">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function remove(id){
    var items = getItems().filter(function(i){ return String(i.id) !== String(id); });
    saveItems(items);
    updateBadge();
    renderItems();
    var btn = document.querySelector('.cg-wish[data-product-id="' + id + '"]');
    if(btn) btn.classList.remove('is-active');
  }

  function openPopup(e){
    if(e) e.preventDefault();
    renderItems();
    var overlay = document.getElementById('WLOverlay');
    var popup   = document.getElementById('WLPopup');
    if(!overlay || !popup) return;
    overlay.classList.add('active');
    setTimeout(function(){ popup.classList.add('active'); }, 10);
    document.body.style.overflow = 'hidden';
  }

  function closePopup(){
    var overlay = document.getElementById('WLOverlay');
    var popup   = document.getElementById('WLPopup');
    if(!overlay || !popup) return;
    popup.classList.remove('active');
    setTimeout(function(){ overlay.classList.remove('active'); }, 300);
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closePopup();
  });

  document.addEventListener('DOMContentLoaded', initButtons);

  return {
    toggle:     toggle,
    remove:     remove,
    openPopup:  openPopup,
    closePopup: closePopup,
    updateBadge: updateBadge
  };

})();